import { createContext, useContext } from 'react';

export type Profile = { token: string; email: string };
export type AdminUser = {
  profile: Profile | undefined;
  isLogin: boolean;
  isInitialized: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
};

export const AdminUserContext = createContext<AdminUser>({
  profile: undefined,
  isLogin: false,
  isInitialized: false,
  login: () => new Promise(() => {}),
  logout: () => {},
});

const useAdminUser = () => useContext(AdminUserContext);
export default useAdminUser;
